<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Gerenciamento de Férias</div>

        <button
          type="button"
          class="btn btn-danger ml-auto mr-2"
          :disabled="!selectedIds.length"
          @click="bulkDestroy"
        >
          Excluir Selecionados ({{ selectedIds.length }})
        </button>

        <router-link to="/vacations/add" class="btn btn-primary">
          Novo Registro
        </router-link>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Ano</label>
              <select class="form-control filter-select" v-model="search.year">
                <option :value="null">Todos</option>
                <option :value="year" v-for="year in years" :key="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="form-group">
              <label>Mês</label>
              <select class="form-control filter-select" v-model="search.month" :disabled="!search.year">
                <option :value="null">Todos</option>
                <option :value="index + 1" v-for="(name, index) in monthNames" :key="index">
                  {{ name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-auto d-flex align-items-end">
            <div class="form-group mb-1">
              <button
                type="button"
                class="btn btn-primary mr-2"
                @click="applyFilter"
              >
                Buscar
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click="clearFilter"
              >
                Limpar
              </button>
            </div>
          </div>
        </div>

        <div v-if="loading" class="text-center" style="padding: 50px;">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p class="mt-2">Carregando registros...</p>
        </div>

        <v-server-table
          v-show="!loading"
          ref="table"
          name="vacationsTable"
          :url="url"
          :columns="columns"
          :options="options"
          @loaded="onTableLoaded"
        >
          <template slot="h__select">
            <input
              type="checkbox"
              class="bulk-checkbox"
              :checked="isAllSelected"
              @change="toggleAll($event.target.checked)"
            />
          </template>

          <div slot="select" slot-scope="props">
            <input
              type="checkbox"
              class="bulk-checkbox"
              :checked="isSelected(props.row.id)"
              @change="toggleRow(props.row.id, $event.target.checked)"
            />
          </div>

          <div slot="actions" slot-scope="props">
            <button
              data-toggle="tooltip"
              title="Editar"
              type="button"
              class="btn btn-crud edit"
              @click="edit(props.row.id)"
            >
              <i class="fas fa-pencil-alt"></i>
            </button>

            <button
              data-toggle="tooltip"
              title="Deletar"
              type="button"
              class="btn btn-crud delete far fa-trash-alt"
              @click="destroy(props.row, props.index)"
            >
              <i class="far fa-trash"></i>
            </button>
          </div>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
const dateFilterColumns = ["start_date", "end_date"];

export default {
  data() {
    const vm = this;

    return {
      loading: true,

      selectedIds: [],
      tableRows: [],

      search: {
        year: null,
        month: null,
      },

      monthNames: [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
      ],

      columns: [
        "select",
        "id",
        "user_id",
        "start_date",
        "end_date",
        "number_of_days",
        "pecuniary_allowance",
        "responsible_id",
        "status",
        "actions",
      ],

      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "user_id",
          "start_date",
          "end_date",
          "number_of_days",
          "pecuniary_allowance",
          "responsible_id",
          "status",
        ],
        sortable: ["id", "title", "date"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        resizableColumns: false,
        columnsClasses: { id: "col-id", select: "col-select" },

        headings: {
          select: "",
          id: "ID",
          user_id: "Colaborador",
          start_date: "Data Início",
          end_date: "Data Fim",
          number_of_days: "Número de Dias",
          pecuniary_allowance: "Abono Pecuniário",
          responsible_id: "Responsável",
          status: "Status",
          actions: "Ações",
        },

        requestFunction(data) {
          const requestData = {
            params: {
              ...data,
              query: "",
              with: ["user", "responsible"],
              year: vm.search.year,
              month: vm.search.month,
            },
          };

          return axios
            .get(this.url + "?" + vm.query(data.query), requestData)
            .catch(function (e) {
              this.dispatch("error", e);
            }.bind(this));
        },

        templates: {
          user_id(_, row) {
            return row.user ? row.user.name : "";
          },
          responsible_id(_, row) {
            return row.responsible ? row.responsible.name : "";
          },
          pecuniary_allowance(_, row) {
            return String(row.pecuniary_allowance) === "1" ? "Sim" : "Não";
          },
          status(_, row) {
            return row.status == 1 ? "Aprovado" : "Não Aprovado";
          },
        },
      },
    };
  },

  computed: {
    url() {
      return this.$store.getters.api + "vacations/";
    },

    years() {
      const currentYear = new Date().getFullYear();
      const firstYear = 2019;
      const availableYears = [];

      for (let year = currentYear; year >= firstYear; year -= 1) {
        availableYears.push(year);
      }

      return availableYears;
    },

    currentPageIds() {
      return this.tableRows.map((row) => row.id);
    },

    isAllSelected() {
      return (
        this.currentPageIds.length > 0 &&
        this.currentPageIds.every((id) => this.selectedIds.includes(id))
      );
    },
  },

  watch: {
    "search.year"(value) {
      if (!value) this.search.month = null;
    },
  },

  methods: {
    onTableLoaded() {
      this.loading = false;
      this.selectedIds = [];
      this.tableRows = (this.$refs.table && this.$refs.table.data) || [];
    },

    applyFilter() {
      this.$refs.table.refresh();
    },

    clearFilter() {
      this.search.year = null;
      this.search.month = null;
      this.$refs.table.refresh();
    },

    isSelected(id) {
      return this.selectedIds.includes(id);
    },

    toggleRow(id, checked) {
      if (checked) {
        if (!this.selectedIds.includes(id)) this.selectedIds.push(id);
      } else {
        this.selectedIds = this.selectedIds.filter((selectedId) => selectedId !== id);
      }
    },

    toggleAll(checked) {
      if (checked) {
        this.selectedIds = [...new Set([...this.selectedIds, ...this.currentPageIds])];
      } else {
        this.selectedIds = this.selectedIds.filter((id) => !this.currentPageIds.includes(id));
      }
    },

    bulkDestroy() {
      const self = this;
      const ids = [...this.selectedIds];

      swal({
        title: `Deseja deletar ${ids.length} registro(s)?`,
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: { text: "Não", value: "cancel", className: "btn-danger" },
          confirm: { text: "Sim", value: "confirm" },
        },
      }).then((value) => {
        if (value !== "confirm") {
          swal("Cancelado", "Os registros não foram excluídos!", "info");
          return;
        }

        Promise.all(ids.map((id) => axios.delete(self.url + id, { id })))
          .then(() => {
            self.selectedIds = [];
            self.$refs.table.refresh();
            swal("Sucesso", "Registros excluídos com sucesso!", "success");
          })
          .catch(() => {
            self.$refs.table.refresh();
            swal("Erro", "Não foi possível excluir alguns registros", "error");
          });
      });
    },

    maskDateFilter(value) {
      const digits = (value || "").replace(/\D/g, "").slice(0, 8);

      if (digits.length <= 2) return digits;
      if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;

      return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    },

    formatDateFilterForApi(value) {
      const match = (value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

      if (!match) return value;

      return `${match[3]}-${match[2]}-${match[1]}`;
    },

    query(query) {
      const self = this;
      const columns = {
        id: "id",
        user_id: "user[name]",
        date: "date",
        start_date: "start_date",
        end_date: "end_date",
        number_of_days: "number_of_days",
        pecuniary_allowance: "pecuniary_allowance",
        responsible_id: "responsible[name]",
        status: "status",
      };

      let filters = "";

      $.each(query, function (index, value) { 
        if (index === "pecuniary_allowance" && value) {
          const filterValue = value.toLowerCase().trim();

          if (filterValue === "sim") value = 1;
          else if (filterValue === "não" || filterValue === "nao") value = 0;
        }

        if (dateFilterColumns.includes(index)) {
          value = self.formatDateFilterForApi(value);
        }

        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },

    edit(id) {
      this.$router.push({ path: "vacations/edit/" + id });
    },

    destroy(row, index) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: { text: "Não", value: "cancel", className: "btn-danger" },
          confirm: { text: "Sim", value: "confirm" },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;
          case "confirm":
            axios
              .delete(this.url + row.id, { id: row.id })
              .then(() => {
                self.$refs.table.data.splice(index - 1, 1);
                swal("Sucesso", "Registro excluído com sucesso!", "success");
              });
            break;
        }
      });
    },
  },

  async mounted() {
    this.loading = true;

    try {
      await this.$nextTick();

      dateFilterColumns.forEach(col => {
        const input = this.$el.querySelector(`input[name="vf__${col}"]`);
        if (input) {
          input.type = "date";
          input.addEventListener("change", () => {
            input.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true }));
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.fas {
  z-index: 99999999 !important;
}

::v-deep .col-id {
  width: 110px;
  min-width: 110px;
}

::v-deep .col-select {
  width: 40px;
  min-width: 40px;
  text-align: center;
}

.filter-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  padding: 0.5rem 2.25rem 0.5rem 0.9rem;
  color: #495057;
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%236c757d' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 10px 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.filter-select:hover:not(:disabled) {
  border-color: #b9c2cc;
}

.filter-select:focus {
  outline: none;
  border-color: #375f9b;
  box-shadow: 0 0 0 3px rgba(55, 95, 155, 0.15);
}

.filter-select:disabled {
  background-color: #f4f6f8;
  color: #adb5bd;
  cursor: not-allowed;
}

.bulk-checkbox {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: #375f9b;
  cursor: pointer;
  border-radius: 4px;
  vertical-align: middle;
}
</style>